import { mock } from "../../conf/context";
import {setAuthenticated, setToken} from "../../reducer/iam/authReducer";
import store from "../../store";
import ajax from "../../lib/appfuse-react/core/ajax";

const authService = {
    login: async (authorization, params={}) => {
        let response;
        try {
            response = await ajax.get('login', params, {
                authorization: authorization
            });
            if(response.authorization) {
                store.dispatch(setToken(response.authorization));
                store.dispatch(setAuthenticated(true));
            }
        } catch(e) {
            store.dispatch(setToken(null));
            store.dispatch(setAuthenticated(false));
            throw e;
        }

        return response.data;
    },
    logout: () => {
        store.dispatch(setToken(null));
        store.dispatch(setAuthenticated(false));
    },
    fetchApplets: async () => {
        const response = await mock.get('applets');
        return response.data;
    },
    verify: async (token, pin) => {
        const authorization = `Bearer ${token}`;
        const response = await ajax.get('login', {}, {
            authorization: authorization,
            headers: {pin}
        });
        if(response.authorization) {
            store.dispatch(setToken(response.authorization));
            store.dispatch(setAuthenticated(true));
        }
    },
    fetchUserInfo: async () => {
        const response = await ajax.get('accounts/myInfo');
        return response.data;
    },
    forgotPassword: async (username) => {
        await ajax.get(`accounts/forgetPassword/${username}`);
    },
    changePassword: async (data) => {
        await ajax.post('accounts/changePassword', data);
    },
}

export default authService;
